import { useState, useEffect, useContext } from 'react';
import { ApplicationContext, AppContext } from '../context/Contexts';
import { ApplicationCodeEnum } from '../helpers/Constants';
import { IReferential } from '../interfaces/IReferential';

const useConnectAppTypeId = (): number | null => {
  const context = useContext(ApplicationContext);
  const legalDocumentService = (context as AppContext).legalDocumentService;
  const [connectAppTypeId, setConnectAppTypeId] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchAppTypes = async () => {
      try {
        const appTypes: IReferential[] = await legalDocumentService.GetAppTypes();
        if (cancelled) return;

        const connectType = appTypes.find(
          (type) => type.code === ApplicationCodeEnum.CONNECT
        );
        setConnectAppTypeId(connectType?.id ?? null);
      } catch (err) {
        console.error('Error fetching app types:', err);
      }
    };

    fetchAppTypes();

    return () => {
      cancelled = true;
    };
  }, [legalDocumentService]);

  return connectAppTypeId;
};

export default useConnectAppTypeId;
